import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Sending from "../shared/loaders/Sending";
import Button from "../shared/button/Button";
import engagedType from "./types/engagedType";
import labels from "./labels";
import {
  DropdownTrigger,
  DropdownWrapper,
  DropdownList,
  DropdownListItem,
  ModalBackdrop,
  Title,
  EditModalWrapper,
  TitleText,
  CloseButton,
  Form,
  Label,
  CompaniesList,
  Company,
  Field,
  TextInput,
  ButtonsWrapper,
  Error,
} from "./styles/message-all-agencies-styles";

class MessageAllAgencies extends Component {
  constructor(props) {
    super(props);
    this.dropdown = React.createRef();

    this.state = {
      dropdownActive: false,
    };
  }

  componentDidMount() {
    this.handleDropdownOutsideClick();
  }

  componentWillUnmount() {
    this.handleDropdownOutsideClick();
  }

  handleAgentsActionBarDropdown = () => {
    this.setState(({ dropdownActive }) => ({
      dropdownActive: !dropdownActive,
    }));
  };

  handleDropdownOutsideClick = () => {
    document.addEventListener("click", (e) => {
      const { dropdownActive } = this.state;
      const dropdown = this.dropdown.current;

      if (dropdownActive === true && e.target !== dropdown) {
        this.setState({ dropdownActive: false });
      }
    });
  };

  render() {
    const { dropdownActive } = this.state;
    const {
      messageAllOnClick,
      messageAllAgenciesModalShown,
      engaged,
      setMessageAllAgenciesMessage,
      closeMessageAllAgenciesModal,
      handleMessageAllAgenciesSubmit,
      formLoading,
      errors,
      showFlashMessage,
    } = this.props;

    return (
      <Fragment>
        <DropdownTrigger
          id="message-all-agencies-trigger"
          showFlashMessage={showFlashMessage}
          ref={this.dropdown}
          onClick={this.handleAgentsActionBarDropdown}
          active={dropdownActive}
        >
          {dropdownActive && (
            <DropdownWrapper active={dropdownActive}>
              <DropdownList>
                <DropdownListItem onClick={messageAllOnClick}>
                  Message All Agencies
                </DropdownListItem>
              </DropdownList>
            </DropdownWrapper>
          )}
          {messageAllAgenciesModalShown && (
            <ModalBackdrop>
              <EditModalWrapper>
                {formLoading && <Sending />}
                <Title>
                  <TitleText>Message All Agencies</TitleText>
                  <CloseButton
                    onClick={() => {
                      closeMessageAllAgenciesModal();
                    }}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </CloseButton>
                </Title>
                <Form
                  onSubmit={handleMessageAllAgenciesSubmit}
                  onKeyPress={this.onKeyPress}
                >
                  <Label>{Parser(labels.messageallAgencies)}</Label>
                  <CompaniesList>
                    {engaged.map((company) => (
                      <Company key={company.recruiterId}>
                        {company.company}
                      </Company>
                    ))}
                  </CompaniesList>
                  <Field>
                    <TextInput
                      placeholder="Enter your message..."
                      onChange={setMessageAllAgenciesMessage}
                    />
                    {errors.initial_message && (
                      <Error>{`Message ${errors.initial_message}.`}</Error>
                    )}
                  </Field>
                  <ButtonsWrapper>
                    <Button
                      secondary
                      buttonName="Cancel"
                      onClickAction={() => {
                        closeMessageAllAgenciesModal();
                      }}
                    />
                    <Button primary buttonName="Send" type="submit" />
                  </ButtonsWrapper>
                </Form>
              </EditModalWrapper>
            </ModalBackdrop>
          )}
        </DropdownTrigger>
      </Fragment>
    );
  }
}

MessageAllAgencies.propTypes = {
  closeMessageAllAgenciesModal: PropTypes.func.isRequired,
  engaged: engagedType.isRequired,
  errors: PropTypes.shape({
    initial_message: PropTypes.string,
  }).isRequired,
  formLoading: PropTypes.bool.isRequired,
  handleMessageAllAgenciesSubmit: PropTypes.func.isRequired,
  messageAllAgenciesModalShown: PropTypes.bool.isRequired,
  messageAllOnClick: PropTypes.func.isRequired,
  setMessageAllAgenciesMessage: PropTypes.func.isRequired,
  showFlashMessage: PropTypes.bool.isRequired,
};

export default MessageAllAgencies;
